import type { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance'

import type { ConfigState, MutationClass } from '../../../models'

export class SetInstancesMutation implements MutationClass {
  static execute(this: void, state: ConfigState, instances: Instance[]): void {
    state.instances = instances
  }
}
